import { motion } from 'framer-motion';
import { LogIn } from 'lucide-react';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';

export const CompleteRegistrationSuccess = () => {
  return (
    <motion.div
      key="password-reset-complete-success"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      <Button className="w-full" asChild>
        <Link to="/login">
          <LogIn className="w-4 h-4 mr-2" />
          Continue to FlagSync
        </Link>
      </Button>
    </motion.div>
  );
};
